export default (entries) => ({
	entries: entries,
	selectedMake: "",
	selectedYear: "",
	selectedSide: "",
	selectedSplit: "",
	displayedLinks: [],

	init() {
		this.$watch("selectedMake", () => {
			this.displayedLinks = [];
			this.selectedYear =
				this.selectedMake && this.availableYears.length === 0 ? "all" : "";
		});
		this.$watch("selectedYear", () => {
			this.displayedLinks = [];
			if (!this.selectedYear) {
				this.selectedSide = "";
				return;
			}
			this.selectedSide = this.availableSides.length === 0 ? "all" : "";
		});
		this.$watch("selectedSide", () => {
			this.displayedLinks = [];
			if (!this.selectedSide) {
				this.selectedSplit = "";
				return;
			}
			this.selectedSplit = this.availableSplits.length === 0 ? "all" : "";
		});
		this.$watch("selectedSplit", () => {
			this.displayedLinks = [];
		});
	},

	get availableMakes() {
		return [...new Set(this.entries.map((item) => item.make))]
			.filter(Boolean)
			.sort();
	},

	get availableYears() {
		if (!this.selectedMake) return [];
		const years = [
			...new Set(
				this.entries
					.filter((item) => item.make == this.selectedMake)
					.map((item) => item.year)
			),
		]
			.filter(Boolean)
			.sort()
			.reverse();

		const hasNoYearOptions = this.entries.some(
			(item) =>
				item.make == this.selectedMake &&
				!item.year &&
				(item.side || item.split)
		);

		if (hasNoYearOptions) {
			years.push("N/A");
		}

		return years;
	},

	get availableSides() {
		if (!this.selectedYear) return [];
		return [
			...new Set(
				this.entries
					.filter((item) => {
						if (item.make != this.selectedMake) return false;
						if (this.selectedYear == "all") return true;
						if (this.selectedYear == "N/A") return !item.year;
						return item.year == this.selectedYear;
					})
					.map((item) => item.side)
			),
		]
			.filter(Boolean)
			.sort();
	},

	get availableSplits() {
		if (!this.selectedSide) return [];
		return [
			...new Set(
				this.entries
					.filter((item) => {
						if (item.make != this.selectedMake) return false;
						if (this.selectedYear != "all") {
							if (this.selectedYear == "N/A") {
								if (item.year) return false;
							} else if (item.year != this.selectedYear) {
								return false;
							}
						}
						if (this.selectedSide != "all" && item.side != this.selectedSide)
							return false;
						return true;
					})
					.map((item) => item.split)
			),
		]
			.filter(Boolean)
			.sort();
	},

	showLinks() {
		this.displayedLinks = this.entries.filter((item) => {
			if (this.selectedMake && item.make != this.selectedMake) return false;
			if (this.selectedYear && this.selectedYear != "all") {
				if (this.selectedYear == "N/A") {
					if (item.year) return false;
				} else if (item.year != this.selectedYear) {
					return false;
				}
			}
			if (
				this.selectedSide &&
				this.selectedSide != "all" &&
				item.side != this.selectedSide
			)
				return false;
			if (
				this.selectedSplit &&
				this.selectedSplit != "all" &&
				item.split != this.selectedSplit
			)
				return false;
			return true;
		});
	},
});
